<template>
  <v-container pa-0 ma-0 class="text-center">
    <v-dialog max-width="300" v-model="newScoreDialog" persistent>
      <the-new-score-dialog @close="setupScore"/>
    </v-dialog>
    <v-row v-if="score" no-gutters justify="center" align="center">
      <v-col :cols="2"/>
      <v-col :cols="8">
        <v-menu offset-y auto
                :close-on-content-click="false"
                transition="scale-transition">
          <template #activator="{ on }">
            <div class="caption text-capitalize font-weight-italic font-weight-black"
                 v-on="on">
              {{ score.name }}
              &nbsp;&nbsp;
              <app-icon icon="edit" :size="15"/>
            </div>
          </template>
          <v-list class="pa-0">
            <v-list-item style="overflow: hidden">
              <v-list-item-title>
                Name: &nbsp;&nbsp;
              </v-list-item-title>
              <v-list-item-title>
                <v-text-field class="body-2" v-model="score.name"/>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
      <v-col :cols="2">
        <v-menu offset-y transition="scale-transition">
          <template #activator="{ on }">
            <v-btn outlined block x-small v-on="on" class="body-2 text-capitalize">
              Options
            </v-btn>
          </template>
          <v-list :dense="$vuetify.breakpoint.xsOnly">
            <!--            <v-list-item @click="upload=true">-->
            <!--              <v-list-item-title>-->
            <!--                Load-->
            <!--              </v-list-item-title>-->
            <!--            </v-list-item>-->
            <v-list-item @click="newScoreDialog=true">
              <v-list-item-title>
                New Score
              </v-list-item-title>
            </v-list-item>
            <!--            <v-list-item @click="timeSignatureDialog = true">-->
            <!--              <v-list-item-title>-->
            <!--                Time Signature-->
            <!--              </v-list-item-title>-->
            <!--            </v-list-item>-->
            <v-list-item @click="scaleDialog = true">
              <v-list-item-title>
                About the Scale
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
      <v-col :cols="12">
        <v-tabs show-arrows
                fixed-tabs
                height="25"
                v-model="activePlayer"
                @change="setActivePlayer"
                :slider-color="$vuetify.theme.dark ? 'white' : 'primary'">
          <v-tab ripple class="text-capitalize text-truncate elevation-1 border" v-for="player in getPlayerNames"
                 :key="player">
            {{ player }}
          </v-tab>
          <v-btn icon class="pb-3" @click="addPlayerDialog=true">
            <app-icon icon="add"/>
          </v-btn>
          <v-tab-item v-for="pName in getPlayerNames"
                      :key="pName"
                      class="theme">
            <div v-if="pName!='drums'" :color="`theme ${$vuetify.theme.dark ? 'lighten' : 'darken'}-2`"
                 class="elevation-4">
              <score-role :player="pName"
                          :score="score"
                          @playMeasure="playMeasure"
                          @voiceChanged="playPiece"
                          @voiceDeleted="voiceDeleted">
                <template #main-settings>
                  <v-col :cols="4">
                    <select-note :icon="true"
                                 :small="$vuetify.breakpoint.smOnly"
                                 :x-small="$vuetify.breakpoint.xsOnly"
                                 color="primary"/>
                  </v-col>
                </template>
                <template #harmony>
                  <select-music-line/>
                </template>
              </score-role>
            </div>
            <div v-else :color="`theme ${$vuetify.theme.dark ? 'lighten' : 'darken'}-2`"
                 class="elevation-4">
              <drums/>
            </div>
          </v-tab-item>
        </v-tabs>
      </v-col>
      <!--            <v-col :cols="12">{{currBeat}}</v-col>-->
      <v-col :cols="12" class="elevation-3 py-1 accent" :style="controllerStyle">
        <v-row justify="center" align="center" no-gutters>
          <v-col :cols="12" v-if="settings">
            <v-row dense justify="center" align="center" class="px-4">
              <v-col>
                <app-slider value-name="BPM" :initial-value="getTransportBPM" :min="40" :max="240"
                            @valueChanged="setBPM"/>
              </v-col>
              <v-col :cols="12">
                <v-divider/>
              </v-col>
              <v-col :cols="6">
                <v-switch ripple color="green"
                          style="justify-content: center;"
                          v-model="metronomeActive"
                          label="Metronome"/>
              </v-col>
              <v-col>
                <v-menu offset-y>
                  <template #activator="{ on }">
                    <v-btn outlined small
                           class="body-1 text-capitalize"
                           color="success"
                           v-on="on">
                      Sound: {{ getMetronomeSound }}
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item v-for="(sound, index) in metronomeSounds"
                                 :key="index"
                                 @click="updateMetronomeSound(sound)">
                      <v-list-item-title>{{ sound }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
          <v-col :cols="12">
            <v-row no-gutters align="center">
              <v-col>
                <v-btn text icon
                       :small="$vuetify.breakpoint.smOnly"
                       :x-small="$vuetify.breakpoint.xsOnly"
                       @click="setLooping"
                       :color="getIsTransportLooping ? 'success' : 'grey'">
                  <app-icon icon="loop" :size="18"/>
                </v-btn>
              </v-col>
              <v-col>
                <v-btn icon outlined
                       :small="$vuetify.breakpoint.smOnly"
                       :x-small="$vuetify.breakpoint.xsOnly"
                       :color="getIsTransportStarted ? 'error' : 'success'"
                       @click="playPiece">
                  <app-icon :icon="getIsTransportStarted ? 'stop' : 'play-arrow'" :size="18"/>
                </v-btn>
              </v-col>
              <v-col>
                <v-btn text icon
                       color="invert"
                       :small="$vuetify.breakpoint.smOnly"
                       :x-small="$vuetify.breakpoint.xsOnly"
                       @click="settings = !settings">
                  <app-icon icon="settings" :size="18"/>
                </v-btn>
              </v-col>
              <v-col>
                <save-button :id="score.name"
                             :data="saveData"
                             type="composition"
                             :db="$store.state.user.compositions">
                  <v-btn icon color="primary" :x-small="$vuetify.breakpoint.xsOnly">
                    <app-icon icon="save" :size="18"/>
                  </v-btn>
                </save-button>
              </v-col>
              <v-col>
                <download-midi @download="download">
                  <v-btn icon small>
                    <app-icon icon="download" :size="20"/>
                  </v-btn>
                </download-midi>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <div class="elevation-5" :style="pianoStyle">
        <app-piano/>
      </div>
      <!--      <v-dialog v-model="upload">-->
      <!--        <file-upload @file-uploded="loadMidi"/>-->
      <!--      </v-dialog>-->
      <v-dialog v-model="scaleDialog" width="500">
        <app-dialog @close="scaleDialog=false">
          <template #title>Scale Information</template>
          <v-card-text class="pa-3">
            <span>
              Name: {{ `${getScale.root.raw} ${getScale.info.name}` }} <br>
              Notes: {{ getScale }} <br>
              Formula(semi-tones): {{ getScale.pattern.join(', ') }}<br>
              Other Names: {{ getScale.info.aka }}
            </span>
          </v-card-text>
          <v-card-actions>
            <v-btn small block color="success"
                   @click="scaleDialog = false">
              OK
            </v-btn>
          </v-card-actions>
        </app-dialog>
      </v-dialog>
      <!--      <v-dialog v-model="timeSignatureDialog" width="500">-->
      <!--        <app-dialog @close="timeSignatureDialog=false">-->
      <!--          <template #title>Time Signature</template>-->
      <!--          <v-row dense class="pa-4">-->
      <!--            <v-col :cols="12">-->
      <!--              <span class="red&#45;&#45;text font-weight-bold">WARNING: The current score will be deleted if you change the time-->
      <!--                Signature.-->
      <!--              </span>-->
      <!--            </v-col>-->
      <!--            <v-col :cols="5"/>-->
      <!--            <v-col :cols="2">-->
      <!--              <v-row no-gutters>-->
      <!--                <v-col :cols="12">-->
      <!--                  <v-text-field class="pa-0"-->
      <!--                                v-model="timeSignature[0]"-->
      <!--                                height="20"-->
      <!--                                type="number"-->
      <!--                                style="max-width: 4vh"/>-->
      <!--                </v-col>-->
      <!--                <v-col>-->
      <!--                  <v-text-field class="pa-0"-->
      <!--                                v-model="timeSignature[1]"-->
      <!--                                height="20"-->
      <!--                                style="max-width: 4vh"-->
      <!--                                type="number"/>-->
      <!--                </v-col>-->
      <!--              </v-row>-->
      <!--            </v-col>-->
      <!--            <v-col :cols="5"/>-->
      <!--            <v-col :cols="6">-->
      <!--              <v-btn small block color="error" @click="timeSignatureDialog = false">-->
      <!--                Cancel-->
      <!--              </v-btn>-->
      <!--            </v-col>-->
      <!--            <v-col :cols="6">-->
      <!--              <v-btn small block color="success"-->
      <!--                     @click="saveTimeSignature">-->
      <!--                OK-->
      <!--              </v-btn>-->
      <!--            </v-col>-->
      <!--          </v-row>-->
      <!--        </app-dialog>-->
      <!--      </v-dialog>-->
      <v-dialog v-model="addPlayerDialog">
        <the-add-player-dialog @close="addPlayerDialog=false" @onPlayerAdded="onPlayerAdded" :score="score"/>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { DRUMS, drumSounds }      from 'misc/Constants'
  import { Transport }              from 'tone'
  import { getScoreHandler }        from 'helpers/note-art-helpers'

  let audioManager

  export default {
    name: 'Studio',

    head: {
      title: function() {
        return {
          inner: 'Studio',
        }
      },
      meta:  [
        {
          name: 'Studio for song template creation',
          content:
                'A studio for creating templates to songs, including harmony, melody and drums in multiple instruments',
          id:   'desc',
        },
      ],
    },

    components: {
      SaveButton:         () => import(/* webpackChunkName: "components" */ 'components/SaveButton'),
      TheNewScoreDialog:  () => import(/* webpackChunkName: "studio" */ 'sections/app/TheNewScoreDialog'),
      ScoreRole:          () => import(/* webpackChunkName: "studio" */ 'sections/app/ScoreRole'),
      // FileUpload:        () => import(/* webpackChunkName: "components" */ 'components/FileUpload'),
      Drums:              () => import(/* webpackChunkName: "studio" */ 'sections/app/Drums'),
      AppSlider:          () => import(/* webpackChunkName: "components" */ 'components/AppSlider'),
      AppDialog:          () => import(/* webpackChunkName: "app-main" */ 'components/AppDialog'),
      SelectMusicLine:    () => import(/* webpackChunkName: "feature-sections" */ 'sections/app/SelectMusicLine'),
      SelectNote:         () => import(/* webpackChunkName: "feature-sections" */ 'sections/app/SelectNote'),
      AppPiano:           () => import(/* webpackChunkName: "components" */ 'components/piano/AppPiano'),
      DownloadMidi:       () => import(/* webpackChunkName: "feature-sections" */ 'sections/app/cards/DownloadMidi'),
      TheAddPlayerDialog: () => import(/* webpackChunkName: "studio" */ 'sections/app/TheAddPlayerDialog'),
    },

    async beforeCreate() {
      await this.$store.dispatch('transport/initPlayersInstruments')
      const module = await import(/* webpackChunkName: "audio-manager" */ 'models/AudioManager')
      audioManager = module.default
      await audioManager.add(DRUMS)
      this.$store.dispatch('visualization/setDrumMatrix')
      if(this.getScore) {
        this.setupScore()
      } else {
        this.newScoreDialog = true
      }
      Transport.loop = true
    },

    beforeDestroy() {
      this.setScore(this.score)
    },

    data() {
      return {
        settings:            false,
        metronomeSounds:     drumSounds,
        scaleDialog:         false,
        timeSignatureDialog: false,
        addPlayerDialog:     false,
        timeSignature:       [4, 4],
        newScoreDialog:      false,
        upload:              false,
        score:               null,
        activePlayer:        0,
      }
    },

    computed: {
      ...mapGetters('transport', [
        'getPlayers',
        'getPlayerID',
        'getPlayerNames',
        'getScore',
        'getIsMetronomeActive',
        'getMetronomeSound',
        'getBeat',
        'getIsTransportLooping',
        'getTransportBPM',
      ]),
      ...mapGetters('transport', ['getIsTransportStarted']),
      ...mapGetters('context', ['getScale']),

      metronomeActive: {
        set() {
          this.setMetronome()
        },
        get() {
          return this.getIsMetronomeActive
        },
      },

      saveData: function() {
        const players = {}
        Object.values(this.getPlayers).forEach(({ name, instrument, volume }) => {
          players[name] = { name, instrument, volume }
        })
        return {
          pitchClass: this.getScale.root.raw,
          data:       { ...this.getScale.info },
          score:      this.score,
          players,
        }
      },

      controllerStyle: function() {
        const pianoHeight  = 20 * this.$store.getters['settings/getPianoKeySizeMultiplier']
        const footerHeight = this.$vuetify.breakpoint.xsOnly ? 45 : 0
        return {
          bottom:   `${pianoHeight + footerHeight}px`,
          zIndex:   5,
          position: 'sticky',
        }
      },

      pianoStyle: function() {
        return {
          bottom:   this.$vuetify.breakpoint.xsOnly ? '45px' : '0px',
          zIndex:   2,
          position: 'sticky',
        }
      },

      // currBeat: function () {
      //   return `Beat: ${this.getBeat}`
      // },
    },

    methods: {
      ...mapActions('transport', [
        'schedulePlayers',
        'toggleMetronome',
        'setTimeSig',
        'createDrumsPart',
        'toggleTransport',
        'setBPM',
        'updateMasterLoop',
        'setMetronomeSound',
        'setScore',
        'playNotes',
        'setPlayerToVisualize',
        'clearParts',
        'deletePlayer',
        'initializePlayersVolume',
      ]),
      ...mapActions('view', ['setSnackbar']),
      ...mapActions('user', ['addMidiFile', 'verifyAuthenticated']),
      setupScore() {
        this.score          = getScoreHandler().cloneScore(this.getScore)
        this.newScoreDialog = false
      },

      playPiece(restart = true, start = null) {
        if(this.score.length) {
          this.schedulePlayers({ score: this.score, isStudio: true })
        } else {
          this.clearParts()
          Transport.loopEnd = '1m'
        }
        this.createDrumsPart()
        if(restart) {
          this.toggleTransport({ start })
        }
      },

      playMeasure(measureIndex) {
        const measuresInScore = parseInt(this.score.length.split(':')[0])
        const timeToStop      = `${measureIndex === measuresInScore ? 0 : measureIndex + 1}m`
        this.playPiece(true, `${measureIndex}m`)
        Transport.schedule(() => {
          this.toggleTransport()
        }, timeToStop)
      },

      updateMetronomeSound(sound) {
        this.setMetronomeSound({ sound })
      },

      setMetronome() {
        this.toggleMetronome()
        const text = `Metronome: ${this.getIsMetronomeActive ? 'On' : 'Off'}`
        this.setSnackbar({ text, timeout: 2000, active: true })
      },

      // saveTimeSignature() {
      //   this.setTimeSig(this.timeSignature)
      //   this.score.timeSignature = this.timeSignature
      //   this.timeSignatureDialog = false
      // },

      setLooping() {
        if(this.score) {
          Transport.setLoopPoints(0, this.score.length)
        }
        this.updateMasterLoop(!this.getIsTransportLooping)
      },

      onPlayerAdded() {
        this.activePlayer    = this.getPlayerNames.length - 1
        this.addPlayerDialog = false
      },

      // async loadMidi(e) {
      //   this.upload = false
      //   const files = e.target.files
      //   if (files.length > 0) {
      //     const file      = files[0]
      //     this.score.name = file.name.split('.')[0]
      //     const reader    = new FileReader()
      //     let notes
      //     reader.onload   = (e) => {
      //       const midi = new Midi(e.target.result)
      //       JSON.stringify(midi, undefined, 2)
      //       // console.log(midi)
      //       midi.tracks.forEach(track => {
      //         notes = track.notes
      //         // console.log(track)
      //         notes.forEach(note => {
      //           this.playNotes({notes: [note.name], dur: note.duration, time: `+${note.time}`})
      //         })
      //
      //         // console.log(track.controlChanges[64])
      //       })
      //     }
      //     reader.readAsArrayBuffer(file)
      //   }
      //   this.$emit('fileUploaded')
      // },

      setActivePlayer() {
        this.setPlayerToVisualize(this.getPlayerID(this.activePlayer))
      },

      voiceDeleted(playerName) {
        this.activePlayer = 0
        this.score.deleteVoice(playerName)
        this.deletePlayer(playerName)
      },

      async download(now = true) {
        const midiHelpers                                                        = await import(/* webpackChunkName: "midi" */ 'helpers/midi-helpers')
        const { voiceToMidiTrack, downloadMultipleFiles, trackToDownloadObject } = midiHelpers
        const files                                                              = []
        const folderName                                                         = this.score.name
        await Promise.all(Object.entries(this.score.voices).map(async ([voiceName, voiceData]) => {
          const track = voiceToMidiTrack(voiceData)
          files.push(await trackToDownloadObject(track, `scores/${folderName}/${voiceName}`))
        }))
        now ? downloadMultipleFiles(files) : files.forEach(file => this.addMidiFile({ file, overwrite: true }))
      },
    },
  }
</script>
